import { cartActionsStyles } from "@insite/content-library/Widgets/Cart/CartActions";
import { css } from "styled-components";

cartActionsStyles.narrowHidden ={
    above: "sm",
    css: css`
        display: flex;
        justify-content: flex-end;
        button {
            min-width: 100%;
        }
    `,
}

cartActionsStyles. wideOverflowMenu = {
    cssOverrides: {
        wrapper: css`
            margin-left: 20px;
            button {
                min-width: 100%;
                &:hover {
                    border: none !important;
                    background: none !important;
                }
                &:focus {
                    outline: none !important;
                }
            }
        `,
    },
}